import { Routes, Route } from "react-router-dom";
import ScrollToTop from "../components/utils/scroll-component";
import { ContactPage } from "../pages/contact";
import { App } from "../pages/main";
import { NotFound } from "../pages/not-found";
import { ProjectsPage } from "../pages/projects";
import { JobsPage } from "../pages/jobs";

export const Router = () => {
  return (
    <ScrollToTop>
      <Routes>
        {/* Common */}
        <Route index element={<App />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="skills" element={<ProjectsPage />} />
        <Route path="jobs" element={<JobsPage />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </ScrollToTop>
  );
};
